module.exports = __webpack_public_path__ + "media/images/product_owners/peo_sda_90-4a82661277a186eef770d50058eddd1e.png";